import React, { useState } from 'react';
import type { User } from '@axiom/validation';

import { PublicEngagementToLoginModal } from '../components/PublicEngagementToLoginModal/PublicEngagementToLoginModal';

type LoginModalComponentProps = {
  user: User | null;
};

export const usePublicEngagementToLoginModal = () => {
  const [
    displayPublicEngagementToLoginModal,
    setDisplayPublicEngagementToLoginModal,
  ] = useState(false);

  const toggleLoginModal = (show: boolean) => {
    setDisplayPublicEngagementToLoginModal(show);
  };

  const LoginModalComponent = ({ user }: LoginModalComponentProps) => {
    return !user && displayPublicEngagementToLoginModal ? (
      <div data-test="MATCHES_LOGIN_CONTAINER">
        <PublicEngagementToLoginModal
          onClose={() => {
            toggleLoginModal(false);
          }}
        />
      </div>
    ) : null;
  };

  return {
    displayPublicEngagementToLoginModal,
    toggleLoginModal,
    LoginModalComponent,
  };
};
